<template>
  <div id="app" class="m-5">
    <router-view />
  </div>
</template>
<script>
import "bootstrap/dist/css/bootstrap.min.css";
import firebase from "firebase/app";
import router from "./router";

export default {
  mounted() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        router.push("/home/items");
      } else {
        router.push("/login");
      }
    });
  }
};
</script>
